import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.EDITED_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/locationEdited.js